import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { PracticalInformationDetails } from 'src/Components/PracticalInformation/PracticalInformationDetails';

type PracticalInformationParams = {
  practicalInformationId: string;
};

const ViewPracticalInformationDrawer = () => {
  const { t } = useTranslation();
  const { practicalInformationId } = useParams<PracticalInformationParams>();

  if (!practicalInformationId) {
    return <Navigate to="/guides" replace />;
  }

  return (
    <AnimatedRoutedDrawer title={t('practicalInformationDrawer.title', 'Information Pratique')}>
      {({ onClose }) => (
        <PracticalInformationDetails
          practicalInformationId={practicalInformationId}
          onClose={onClose}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default ViewPracticalInformationDrawer;
